import React, { useContext, useEffect } from 'react'
import { Route, Routes, useNavigate } from "react-router-dom";
import PageNotFound from '../pages/PageNotFound';
import AuthRoutes from './AuthRoutes';
import UnAuthRoutes from './UnAuthRoutes';
import Test from '../pages/test'
import CreateProductionOwnerProfile from '../pages/viewProfile/createProductionOwnerProfile/index'
import CreateSupplierProfile from '../pages/viewProfile/createSupplierProfile';
import ForgotPassword from '../pages/signIn/forgotPassword';
import ResetPassword from '../pages/signIn/resetPassword';
import VerifyEmail from '../pages/signUp/verifyEmail';
import Signup from '../pages/signUp/signup';
import { routes } from '../utils/routesConstants';
import SignIn from '../pages/signIn';
import ViewProfile from '../pages/viewProfile'
import Subscription from '../pages/subscription';
import Suppliers from '../pages/suppliers';
import CrewMembers from '../pages/crewMembers';
import JobList from '../pages/jobsManagement';
import Notifications from '../pages/notification';
import Schedule from '../pages/scheduleManagement';
import { cookieService } from '../services';
import { cookieServiceParam } from '../utils/constants';
import { MyContext } from '../context';
import { PERMISSION_TYPE, ROLE_TYPE } from '../types';
import PaymentComplete from '../components/stripe/PaymentComplete';
import { SubscriptionExpire } from '../pages/subscription/SubscriptionExpire';
import BackPages from '../pages/backPages';
import CrewGroups from '../pages/crewGroups';
import Messages from '../pages/chatManagement/Messages';
import OnboardingStart from '../pages/OnboardingStart';
import CrewProfileSetup from '../pages/profileSetupV2/crewProfileSetup';
import LegalsV2 from '../pages/legalPages/LegalV2';
import CrewSignUp from '../pages/signUp/CrewSignUp';
import Share from '../pages/share';
import UpdateCv from '../pages/viewProfile/UpdateCrewCv';
import { getCompanyName } from '../utils';
import LocationVault from '../pages/locationManagement/locationVault';
import LocationMarketplace from '../pages/locationManagement/locationMarketplace';
import LocationDetail from '../pages/locationManagement/locationDetail';
import LocationVaultGallery from '../pages/locationManagement/locationVaultGallery';
import Communication from '../pages/locationManagement/communication';
import Sharing from '../pages/locationManagement/sharing';
import LocationFolders from '../pages/locationManagement/locationFolders';
import UsersPermissionsAndAudit from '../pages/locationManagement/userAndAudit';
import MFA from '../pages/mfa';

const RouteStack: React.FC = (props) => {

    const { userData } = useContext(MyContext);
    const navigate = useNavigate()
    const isAuthenticated = cookieService.getCookie(cookieServiceParam.token) ? true : false;
    const paymentData = cookieService.getCookie(cookieServiceParam.payment_data) ? true : false;

    useEffect(() => {
        let routeUrls: string = '';

        const isCrew = userData?.user_type === ROLE_TYPE.TYPE_CREW;
        const isProdOwner = userData?.permission_type === PERMISSION_TYPE.TYPE_PROD_OWNER;
        const isCrewMember = userData?.permission_type === PERMISSION_TYPE.TYPE_CREW_MEMBER;
        const productionCompanyName = getCompanyName(userData)

        if (isAuthenticated && isCrew && !isCrewMember && !isProdOwner) {
            routeUrls = '/schedule';
        } else if (isAuthenticated && userData && !userData.subscription_id && !userData.account_completed && userData?.user_type !== 'C') {
            routeUrls = paymentData ? '/payment-success/?payment_status=error' : '/subscription';
        } else if (isAuthenticated && userData?.account_completed && !userData?.subscription_id && userData?.user_type !== 'C') {
            routeUrls = paymentData ? '/payment-success/?payment_status=error' : userData.user_type === ROLE_TYPE.TYPE_SUPPLIER ? '/expire-subscription' : '/subscription';
        } else if (isAuthenticated && !userData?.account_completed && isCrew && isCrewMember) {
            routeUrls = 'manage-profile/crew/add/1';
        } else if (isAuthenticated && userData?.account_completed && isProdOwner && isCrew) {
            if (!productionCompanyName) {
                routeUrls = '/manage-profile/owner/add/1';
            } else if (!userData?.owner_profile?.seventh_day_earning_rates || !userData?.owner_profile?.sixth_day_earning_rates) {
                routeUrls = '/manage-profile/owner/add/3';
            }
        }

        if (routeUrls) {
            const timer = setTimeout(() => {
                navigate(routeUrls);
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [userData?.subscription_id]);

    return (
        <>
            <div className='payment-layout' id='my_container' />
            <Routes>
                {/* Public Routes */}
                <Route element={<UnAuthRoutes />}>
                    <Route path={routes.onboarding} element={<OnboardingStart />} />
                    <Route path={routes.forgotPassword} element={<ForgotPassword />} />
                    <Route path={routes.resetPassword} element={<ResetPassword />} />
                    <Route
                        path={routes.supplier_signup}
                        element={<Signup />}
                    />
                    <Route
                        path={routes.sign_in}
                        element={<SignIn />}
                    />

                    <Route
                        path='/mfa-authentication'
                        element={<MFA />}
                    />

                    <Route
                        path={routes.crew_signup}
                        element={<CrewSignUp />}
                    />
                    <Route path={routes.legals_page} element={<LegalsV2 />} />
                </Route>

                {/* Private Routes */}
                <Route element={<AuthRoutes />}>
                    <Route path='/update-cv' element={<UpdateCv />} />
                    <Route path='/location/:type' element={<LocationVault />} />
                    <Route path='/location-folders/:type/:id' element={<LocationFolders />} />
                    <Route path='/location-detail/:type/:id' element={<LocationDetail />} />
                    <Route path='/location-gallery/:type/:id' element={<LocationVaultGallery />} />
                    <Route path='/location-communication/:type/:id' element={<Communication />} />
                    <Route path='/location-sharing/:type/:id' element={<Sharing />} />
                    <Route path='/location-marketplace' element={<LocationMarketplace />} />
                    <Route path='/users-audit' element={<UsersPermissionsAndAudit />} />
                    <Route path={routes.verifyEmail} element={<VerifyEmail />} />
                    <Route path={routes.subscription} element={<Subscription />} />
                    <Route path={routes.expireSubscription} element={<SubscriptionExpire />} />
                    <Route
                        path={routes.createOwnerProfile}
                        element={<CreateProductionOwnerProfile />}
                    />
                    <Route
                        path={routes.viewProfile}
                        element={<ViewProfile />}
                    />
                    <Route
                        path={routes.createSupplierProfile}
                        element={<CreateSupplierProfile />}
                    />
                    <Route
                        path={routes.crew_profile_setup}
                        element={<CrewProfileSetup />}
                    />
                    <Route path={routes.jobs} element={<JobList />} />
                    {/* <Route path={routes.messages} element={<Messages />} /> */}
                    <Route path={routes.messages} element={<Messages />} />
                    <Route path={routes.schedule} element={<Schedule />} />
                    <Route path={routes.suppliers} element={<Suppliers />} />
                    <Route path={routes.explore} element={<CrewMembers />} />
                    <Route path={routes.notifications} element={<Notifications />} />
                    <Route path={routes.back_pages} element={<BackPages />} />
                    <Route path={routes.crew_groups} element={<CrewGroups />} />
                    <Route path={routes.paymentComplete} element={<PaymentComplete />} />
                </Route>
                <Route path={'/test'} element={<Test />} />
                <Route path='/share' element={<Share />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </>
    )

}

export default RouteStack;